import { stripeModule } from '@/store/stripe/module'
import { isPromise } from '@/utils'

const getStripe = () => {
    return stripeModule.state.stripe
}

const getElements = () => {
    return stripeModule.state.elements
}

const getStripePaymentMethods = () => {
    const stripePaymentMethods = stripeModule.state.payment.value
    if (isPromise(stripePaymentMethods)) {
        return []
    } else {
        const paymentMethods = stripePaymentMethods.paymentMethods

        const currentMonth = new Date().getMonth() + 1
        const currentYear = Number(new Date().getFullYear().toString()
            .slice(-2))

        // filter out expired cards before looking for identical fingerPrints
        paymentMethods.filter((pm) => {
            if (pm?.card) {
                if (pm.card?.exp_year > currentYear) {
                    return pm
                }
                if (pm.card?.exp_year === currentYear && pm.card?.exp_month >= currentMonth) {
                    return pm
                }
            }
            return
        })

        // filter out duplicate cards by fingerPrint
        return paymentMethods.filter((value, index, pm) =>
            index === pm.findIndex((method) => (
                method.card?.fingerprint === value.card?.fingerprint
            ))
        )
    }
}

const getReceipts = () => {
    const receipts = stripeModule.state.receipts.value
    if (isPromise(receipts)) {
        return []
    } else {
        return receipts
    }
}

export default {
    getStripe,
    getElements,
    getReceipts,
    getStripePaymentMethods,
}
